module.exports = __webpack_public_path__ + "static/media/BTC-USDC.7451c2c9.svg";